
export default function AboutContent() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-3xl font-bold text-slate-900 mb-4 font-poppins">
            Hakkımızda
          </h2>
          <div className="w-16 h-0.5 bg-slate-900 mx-auto mb-6"></div>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="text-center space-y-6 text-slate-600 leading-relaxed">
            <p className="text-lg animate-fade-in-up font-poppins font-normal" style={{ animationDelay: '0.1s' }}>
              Hukuk büromuz, müvekkillerine yalnızca yasal temsilci olmaktan öte, güvenilir bir çözüm ortağı 
              olma felsefesiyle hizmet vermektedir. Avukatlık mesleğine olan derin bağlılık ve titiz çalışma 
              disiplini ile her davaya yaklaşırız.
            </p>
            
            <p className="text-lg animate-fade-in-up font-poppins font-normal" style={{ animationDelay: '0.2s' }}>
              Özellikle Ceza Hukuku, Aile Hukuku, Miras Hukuku ve İş Hukuku alanlarında edindiğimiz geniş tecrübe ile 
              karmaşık hukuki problemlere pratik ve önleyici çözümler sunmaktayız.
            </p>
            
            <p className="text-lg animate-fade-in-up font-poppins font-normal" style={{ animationDelay: '0.3s' }}>
              Modern hukuk anlayışını geleneksel değerlerle harmanlayarak, müvekkillerimize kapsamlı 
              ve güvenilir hukuki hizmetler sunuyoruz. Şeffaflık, dürüstlük ve mükemmellik arayışı 
              çalışmalarımızın temel taşlarıdır.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <div className="text-center animate-fade-in-up hover-lift" style={{ animationDelay: '0.4s' }}>
              <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-scales-3-line text-xl text-slate-700"></i>
              </div>
              <h3 className="font-semibold text-slate-900 mb-2 font-poppins">Önleyici Hukuk</h3>
              <p className="text-sm text-slate-600 font-poppins font-light">Olası riskleri minimize etmek için risk analizi ve sözleşme denetimi</p>
            </div>
            
            <div className="text-center animate-fade-in-up hover-lift" style={{ animationDelay: '0.5s' }}>
              <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-xl text-slate-700"></i>
              </div>
              <h3 className="font-semibold text-slate-900 mb-2 font-poppins">Stratejik Çözüm</h3>
              <p className="text-sm text-slate-600 font-poppins font-light">Müvekkilin hedeflerine uygun, uzun vadeli stratejiler geliştirme</p>
            </div>
            
            <div className="text-center animate-fade-in-up hover-lift" style={{ animationDelay: '0.6s' }}>
              <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-line text-xl text-slate-700"></i>
              </div>
              <h3 className="font-semibold text-slate-900 mb-2 font-poppins">Şeffaflık</h3>
              <p className="text-sm text-slate-600 font-poppins font-light">Tüm süreç boyunca müvekkili net ve anlaşılır şekilde bilgilendirme</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}